export default {
  checkCollection: '/auth/collection/checkCollection',
  addCollection: '/auth/collection/save',
  removeCollection: '/auth/collection/remove',
  getCollectionCounts: '/auth/collection/counts',
  getCollectionList: '/auth/collection/findList'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/favorite.js